import { ApiService } from '../ApiService';
import { type Payment, type PaymentInfo } from './types';

export const getPaymentInfo = async (externalId: number): Promise<PaymentInfo> => {
  const response = await ApiService.instance.get(`game/v1/payment/${externalId}`);

  return await response?.data;
};

export const requestPayment = async (
  data: Payment,
  standaloneBot?: string | null
): Promise<{ url: string }> => {
  const payload = standaloneBot ? { ...data, standaloneBot } : data;

  const response = await ApiService.instance.post('game/v1/payment', payload);

  return await response?.data;
};
